import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import rootReducer from '../reducer';
const store = createStore(
  combineReducers(rootReducer),
  composeWithDevTools({})(applyMiddleware(thunk))
);

console.log("store:", store)
export default store
